/* eslint-disable */
import { FC } from 'react';

import { Button } from '@base-app';

import './HTMLText.scss';
import { FOOTER_URL } from '../../Footer/Footer.types';
interface HTMLTextProps {}

const HTMLText: FC<HTMLTextProps> = () => {
  return (
    <div className="c13 doc-content terms-of-service">
      <span className="c23">
        <h1 className="c2 c19">Helix Builder Terms of Service</h1>
      </span>
      <div className="c4">
        <span className="c2 c21">
          We have updated our terms to reflect changes to our business model, provide additional clarity on our
          processing of personal information, and address evolving privacy law requirements. We encourage you to review
          our updated Terms of Service here and{' '}
          <span className="c2 c21 c22">
            <a className="c15" rel="noopener" target="_blank" href={FOOTER_URL.PRIVACY}>
              Privacy Policy
            </a>
          </span>
          . By continuing, you acknowledge and agree to the updated terms listed here.
        </span>
      </div>
      <div className="c4">
        <span className="c1">
          Helix, Inc. and/or its affiliates (&ldquo;Helix&rdquo;, &ldquo;we&rdquo;, &ldquo;us&rdquo;) provide an online
          web portal through which it makes available on-demand data insights regarding certain activities which are a
          part of collaborative{' '}
        </span>
        <span className="c1">research programs</span>
        <span className="c1">
          &nbsp;and laboratory services provided to its partners (the &ldquo;Helix Builder&rdquo;). Your access to and
          use of Helix Builder is subject to the following terms and conditions.{' '}
        </span>
      </div>

      <div className="c4">
        <span className="c2 c21">
          By accessing or using Helix Builder, you acknowledge that you are an authorized representative of an entity
          collaborating on a research program or receiving laboratory services from Helix, and agree to be bound and
          abide by these Terms of Service. Please read them with care
        </span>
        <span className="c1">
          . You acknowledge that Helix has entered into an agreement for collaborative research and/or laboratory
          services with the entity you represent (the &ldquo;Agreement&rdquo;) which may include terms that further
          govern your use of Helix Builder, and Helix has assigned a representative to assist with management of the
          Agreement and Helix Builder (the &ldquo;Partner Manager&rdquo;).
        </span>
      </div>

      <ol className="c11 lst-kix_list_28-0">
        <li className="c4 c5 li-bullet">
          <h2>1. Changes to these Terms of Service and Helix Builder</h2>
        </li>
      </ol>

      <div className="c4">
        <span className="c1">Your use of </span>
        <span className="c1">Helix Builder</span>
        <span className="c1">&nbsp;is also subject to any applicable terms, policies, including Helix&rsquo;s </span>
        <span className="c1 c22">
          <a className="c15" rel="noopener" target="_blank" href={FOOTER_URL.PRIVACY}>
            Privacy Policy
          </a>
        </span>
        <span className="c1">, or rules that we may post or provide a link to on </span>
        <span className="c1">Helix Builder</span>
        <span className="c8 c1">. </span>
      </div>

      <div className="c4">
        <span className="c1">
          We may revise and update these Terms of Service from time to time and post the updated Terms of Service on{' '}
        </span>
        <span className="c1">Helix Builder</span>
        <span className="c1">
          . All changes are effective immediately when we post them, and they apply to all access to and use of{' '}
        </span>
        <span className="c1">Helix Builder</span>
        <span className="c1">&nbsp;from that point onward. If you use </span>
        <span className="c1">Helix Builder</span>
        <span className="c1">
          &nbsp;after we post revised Terms of Service, you acknowledge and agree to the revised Terms of Service.{' '}
        </span>
      </div>

      <div className="c4">
        <span className="c1">
          We reserve the right to modify or remove Helix Builder or any portion thereof in our sole discretion without
          notice. We will not be liable if for any reason Helix Builder is unavailable at any time or for any period.
        </span>
      </div>

      <ol className="c11 lst-kix_list_28-0">
        <li className="c4 c5 li-bullet-0">
          <h2>2. Prohibited Uses</h2>
        </li>
      </ol>

      <div className="c4">
        <span className="c1">
          Subject to the applicable terms herein, and any other applicable terms and policies, Helix hereby grants you a
          non-exclusive, non-transferable, non-sublicensable license to use Helix Builder only in connection with the
          services provided to you by Helix under the Agreement. You may use Helix Builder only for lawful purposes and
          in accordance with these Terms of Service. You agree not to use Helix Builder in any way that violates any
          applicable federal, state, local or international law or regulation. You also agree not to:
        </span>
      </div>

      <ul className="c11 lst-kix_list_27-0">
        <li className="c3 li-bullet-0">
          <span className="c1">use Helix Builder if you are barred from doing so under any applicable laws; </span>
        </li>
        <li className="c3 li-bullet-0">
          <span className="c1">use </span>
          <span className="c1">Helix Builder</span>
          <span className="c1">&nbsp;in any way that could disable, overburden, damage, or impair </span>
          <span className="c1">Helix Builder</span>
          <span className="c1">; </span>
        </li>
        <li className="c3 li-bullet-0">
          <span className="c1">use </span>
          <span className="c1">Helix Builder</span>
          <span className="c1">&nbsp;in any way that could interfere with any other party&rsquo;s use of </span>
          <span className="c1">Helix Builder</span>
          <span className="c1">;</span>
        </li>
        <li className="c3 li-bullet-0">
          <span className="c1">reverse engineer, copy, modify or create derivative works of the software used in </span>
          <span className="c1">Helix Builder</span>
          <span className="c1">;</span>
        </li>
        <li className="c3 li-bullet-0">
          <span className="c1">use any robot, spider or other automatic device, process or means to access </span>
          <span className="c1">Helix Builder</span>
          <span className="c1">&nbsp;for any purpose, including monitoring or copying any of the material on </span>
          <span className="c1">Helix Builder</span>
          <span className="c1">, unless explicitly permitted by Helix;</span>
        </li>
        <li className="c3 li-bullet-0">
          <span className="c1">
            engage in framing, mirroring, or otherwise simulating the appearance or function of{' '}
          </span>
          <span className="c1">Helix Builder</span>
          <span className="c1">;</span>
        </li>
        <li className="c3 li-bullet-0">
          <span className="c1">use any device, software or routine that interferes with the proper working of </span>
          <span className="c1">Helix Builder</span>
          <span className="c1">;</span>
        </li>
        <li className="c3 li-bullet-0">
          <span className="c1">
            introduce any viruses, Trojan horses, worms, or other material which is malicious or technologically
            harmful;
          </span>
        </li>
        <li className="c3 li-bullet-0">
          <span className="c1">
            attempt to gain unauthorized access to, interfere with, damage or disrupt any parts of{' '}
          </span>
          <span className="c1">Helix Builder</span>
          <span className="c1">, the server on which </span>
          <span className="c1">Helix Builder</span>
          <span className="c1">&nbsp;is stored, or any server, computer or database connected to </span>
          <span className="c1">Helix Builder</span>
          <span className="c1">;</span>
        </li>
        <li className="c3 li-bullet-0">
          <span className="c1">attack </span>
          <span className="c1">Helix Builder</span>
          <span className="c1">&nbsp;via a denial-of-service attack or a distributed denial-of-service attack;</span>
        </li>
        <li className="c3 li-bullet-0">
          <span className="c1">attempt to bypass methods that Helix may use to prevent or restrict access to </span>
          <span className="c1">Helix Builder</span>
          <span className="c1">;</span>
        </li>
        <li className="c3 li-bullet-0">
          <span className="c1">
            grant access to unauthorized third parties or disclose login credentials to third parties;
          </span>
        </li>
        <li className="c3 li-bullet-0">
          <span className="c1">access or attempt to access another user&rsquo;s account; or</span>
        </li>
        <li className="c3 li-bullet-0">
          <span className="c1">access or use the Helix Builder in any way that violates the Agreement;</span>
        </li>
        <li className="c3 li-bullet-0">
          <span className="c1">otherwise attempt to interfere with the proper working of </span>
          <span className="c1">Helix Builder</span>
          <span className="c1">.</span>
        </li>
      </ul>
      <ol className="c11 lst-kix_list_28-0">
        <li className="c4 c5 li-bullet-0">
          <h2>3. Accessing Helix Builder</h2>
        </li>
      </ol>

      <div className="c4">
        <span className="c1">
          Your entity has assigned one or more individuals who are designated to receive an administrator-level account
          on Helix Builder (&ldquo;Administrator&rdquo;). If you believe you should be an Administrator, please contact
          your existing Administrator or Partner Manager to receive Administrator-level access.
        </span>
      </div>

      <div className="c4">
        <span className="c1">
          To access Helix Builder, you must contact your Administrator to receive an account. Helix Builder allows user
          authentication either via Single Sign On (SSO) using your health system&rsquo;s chosen identity provider or
          via Two Factor Authentication (2FA).
        </span>
      </div>

      <div className="c4">
        <span className="c1">
          If your entity supports 2FA, Administrators have the authority to add individual users to your entity&rsquo;s
          instance of Helix Builder by adding your name and email address to the Administrator portion of Helix Builder.
          You will then receive an invitation email to the email address entered by your Administrator. Each individual
          email address may only be used by the authorized individual. For purposes of 2FA, you will be asked to provide
          a mobile phone number upon your first login. You will be prompted to authenticate your identity each time you
          log in to Helix Builder. At time of login, you will receive a prompt via SMS text message to this mobile phone
          number with a code to authenticate your identity. In the event you need to change your number, please contact
          your Administrator or Partner Manager to reset your 2FA process.
        </span>
      </div>

      <div className="c4">
        <span className="c1">
          If your entity supports Single Sign On (SSO) user authentication using your entity&rsquo;s selected identity
          provider, your entity&rsquo;s technical team will be responsible for granting access to Helix Builder for each
          account. Once access is granted, you will be able to authenticate into Helix Builder using your health
          system&rsquo;s login credentials.
        </span>
      </div>

      <div className="c4">
        <span className="c1">
          For users logging in via 2FA, when you first log into your account, you must choose a new password and treat
          your password as confidential. For users logging in via SSO, you will log into Helix Builder using your health
          system&rsquo;s login credentials provided by your health system&rsquo;s technical team. You agree not to let
          someone else access Helix Builder using your username, password or other security information. You agree to
          let us know immediately of any unauthorized access to or use of your username or password or any other breach
          of security.
        </span>
      </div>

      <div className="c4">
        <span className="c1">
          In the event you download or otherwise remove any data from Helix Builder, you are responsible for maintaining
          the confidentiality and security of such data in accordance with applicable law and the terms of the
          Agreement. You agree to let us know immediately of any ​​unauthorized access to the data outside of Helix
          Builder.
        </span>
      </div>

      <div className="c4">
        <span className="c1">
          If we believe that you have violated these Terms of Service, we have the right at any time to disable your
          username, password or any of your identifiers, whether chosen by you or provided by us.
        </span>
      </div>

      <ol className="c11 lst-kix_list_28-0">
        <li className="c4 c5 li-bullet-0">
          <h2>4. Communications </h2>
        </li>
      </ol>

      <div className="c4">
        <span className="c1">You are communicating with us electronically when you use </span>
        <span className="c1">Helix Builder</span>
        <span className="c1">
          &nbsp;or send us emails and other communications from your desktop or mobile device.{' '}
        </span>
        <span className="c1">
          You agree to receive electronically all communications from us in connection with your account or your use of{' '}
        </span>
        <span className="c1">Helix Builder</span>
        <span className="c1">, which may include</span>
        <span className="c1">&nbsp;emails</span>
        <span className="c1">&nbsp;or messages on </span>
        <span className="c1">Helix Builder</span>
        <span className="c1">.</span>
      </div>

      <div className="c4">
        <span className="c1">
          You may retain copies of these communications for your records. You agree that all digital agreements,
          notices, disclosures, and other communications that we provide to you meet any legal requirement that such
          communications be in writing.
        </span>
      </div>

      <ol className="c11 lst-kix_list_28-0">
        <li className="c4 c5 li-bullet-0">
          <h2>5. Intellectual Property Rights</h2>
        </li>
      </ol>

      <div className="c4">
        <span className="c1">Helix Builder</span>
        <span className="c1">, its features and functionality, </span>
        <span className="c1">and the presentation of its content</span>
        <span className="c1">
          &nbsp;are owned by Helix and its licensors and are protected by United States and international copyright,
          trademark, patent, trade secret and other intellectual property or proprietary rights laws.{' '}
        </span>
      </div>

      <div className="c4">
        <span className="c1">No right, title or interest in or to </span>
        <span className="c1">Helix Builder</span>
        <span className="c1">&nbsp;or any content on </span>
        <span className="c1">Helix Builder</span>
        <span className="c1">
          &nbsp;is transferred to you. Helix reserves all rights not expressly granted. If you provide Helix with any
          suggestions, recommendations or other feedback regarding{' '}
        </span>
        <span className="c1">Helix Builder</span>
        <span className="c1">
          &nbsp;(&ldquo;Feedback&rdquo;), you agree that Helix may freely use and exploit such Feedback in any way and
          for any purpose. Any use of{' '}
        </span>
        <span className="c1">Helix Builder</span>
        <span className="c1">
          &nbsp;not expressly permitted by these Terms of Service is a breach of these Terms of Service and may violate
          copyright, trademark and other laws.
        </span>
      </div>

      <ol className="c11 lst-kix_list_28-0">
        <li className="c4 c5 li-bullet-0">
          <h2>6. Trademarks</h2>
        </li>
      </ol>
      <div className="c4">
        <span className="c1">
          The Helix name and logo are trademarks of Helix. You must not use Helix trademarks without the prior written
          permission of Helix.
        </span>
      </div>
      <ol className="c11 lst-kix_list_28-0">
        <li className="c4 c5 li-bullet-0">
          <h2>7. Geographic Restrictions</h2>
        </li>
      </ol>
      <div className="c4">
        <span className="c1">Helix is a United States company and provides </span>
        <span className="c1">Helix Builder</span>
        <span className="c1">&nbsp;in the United States. We make no claims that </span>
        <span className="c1">Helix Builder</span>
        <span className="c1">
          &nbsp;or any of its content are accessible or appropriate outside of the United States. Access to{' '}
        </span>
        <span className="c1">Helix Builder</span>
        <span className="c1">&nbsp;may not be legal by certain persons or in certain countries. If you access </span>
        <span className="c1">Helix Builder</span>
        <span className="c1">
          &nbsp;from outside the United States, you do so on your own initiative. If you do so, you will be responsible
          for compliance with local laws
        </span>
        <span className="c0">.</span>
      </div>
      <ol className="c11 lst-kix_list_28-0">
        <li className="c4 c5 li-bullet-0">
          <h2>8. Disclaimer of Warranties</h2>
        </li>
      </ol>

      <div className="c4">
        <span className="c1">
          YOUR USE OF HELIX BUILDER, ITS CONTENT, AND ANY FEATURES OR ITEMS OBTAINED THROUGH HELIX BUILDER IS AT YOUR
          OWN RISK.{' '}
        </span>
        <span className="c1">HELIX BUILDER</span>
        <span className="c1">, ITS CONTENT, AND ANY FEATURES OR ITEMS OBTAINED THROUGH </span>
        <span className="c1">HELIX BUILDER</span>
        <span className="c1">
          &nbsp;ARE PROVIDED ON AN &ldquo;AS IS&rdquo; AND &ldquo;AS AVAILABLE&rdquo; BASIS, WITHOUT ANY WARRANTIES OF
          ANY KIND, EITHER EXPRESS, IMPLIED OR STATUTORY,{' '}
        </span>
        <span className="c1">
          INCLUDING BUT NOT LIMITED TO ANY WARRANTY THAT HELIX BUILDER WILL BE ERROR-FREE OR THAT ACCESS WILL BE
          UNINTERRUPTED
        </span>
        <span className="c1">.</span>
      </div>

      <div className="c4">
        <span className="c1">
          THE FOREGOING DOES NOT AFFECT ANY WARRANTIES WHICH CANNOT BE EXCLUDED OR LIMITED UNDER APPLICABLE LAW.
        </span>
      </div>

      <ol className="c11 lst-kix_list_28-0">
        <li className="c4 c5 li-bullet-0">
          <h2>9. Limitation of Liability</h2>
        </li>
      </ol>

      <div className="c4">
        <span className="c1">
          IN NO EVENT WILL HELIX, ITS AFFILIATES OR THEIR LICENSORS, SERVICE PROVIDERS, EMPLOYEES, AGENTS, OFFICERS OR
          DIRECTORS BE LIABLE FOR DAMAGES OF ANY KIND, UNDER ANY LEGAL THEORY, ARISING OUT OF OR IN CONNECTION WITH YOUR
          USE OF HELIX BUILDER, INCLUDING ANY DIRECT, INDIRECT, SPECIAL, INCIDENTAL, CONSEQUENTIAL OR PUNITIVE DAMAGES,
          INCLUDING BUT NOT LIMITED TO, PERSONAL INJURY, PAIN AND SUFFERING, EMOTIONAL DISTRESS, LOSS OF REVENUE, LOSS
          OF PROFITS, LOSS OF BUSINESS OR ANTICIPATED SAVINGS, LOSS OF USE, LOSS OF GOODWILL, LOSS OF DATA, AND WHETHER
          CAUSED BY TORT (INCLUDING NEGLIGENCE), BREACH OF CONTRACT OR OTHERWISE, EVEN IF FORESEEABLE.
        </span>
      </div>

      <div className="c4">
        <span className="c1">
          THE FOREGOING DOES NOT AFFECT ANY LIABILITY WHICH CANNOT BE EXCLUDED OR LIMITED UNDER APPLICABLE LAW.
        </span>
      </div>

      <ol className="c11 lst-kix_list_28-0">
        <li className="c4 c5 li-bullet-0">
          <h2>10. Termination </h2>
        </li>
      </ol>

      <div className="c4">
        <span className="c1">You may discontinue use of Helix Builder at any time.</span>
      </div>

      <div className="c4">
        <span className="c1">
          If you violate these Terms of Service, Helix has the right to terminate your access to all or part of Helix
          Builder. Helix has the right to terminate all accounts that have been inactive for at least thirty (30) days.
        </span>
      </div>

      <div className="c4">
        <span className="c1">
          In the event of termination of the Agreement, your right to access to Helix Builder will be immediately
          terminated.
        </span>
      </div>

      <ol className="c11 lst-kix_list_28-0">
        <li className="c4 c5 li-bullet-0">
          <h2>11. Third Party Offerings</h2>
        </li>
      </ol>

      <div className="c4">
        <span className="c1">
          As an added convenience to you, Helix Builder also may offer you access to third party services via Helix
          Builder. Access to and use of these third party services through Helix Builder is entirely in your discretion.
        </span>
      </div>

      <div className="c4">
        <span className="c1">
          You acknowledge that all third party content is developed by the applicable third party and not Helix. If you
          have any questions, concerns, or require support with regards to any third party content or services please
          contact the third party for assistance with resolving any issues. In the event you are unable to contact the
          third party, please connect with your Partner Manager for assistance.{' '}
        </span>
      </div>

      <div className="c4">
        <span className="c1">
          We urge you to read the applicable third party terms of service, privacy policy, and/or product consent
          relating to any services with care before engaging with such services.
        </span>
      </div>

      <ol className="c11 lst-kix_list_28-0">
        <li className="c4 c5 li-bullet-0">
          <h2>12. Your Comments and Concerns</h2>
        </li>
      </ol>

      <div className="c4">
        <span className="c1">If you have any </span>
        <span className="c1">feedback</span>
        <span className="c1">, comments, requests for support, or other communications about </span>
        <span className="c1">Helix Builder</span>
        <span className="c1">, you should contact your Partner Manager. </span>
      </div>

      <div className="c4">
        <span className="c1 c6">Updated: 2025-04-14</span>
      </div>
    </div>
  );
};

export default HTMLText;
